var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReply = function SvgReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 18,
    height: 18,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.3 479.9c-.4 0-.8 0-1.2-.1-7.5-.6-13.3-7.1-13.3-14.9C7.8 208.3 164 139 257 129.4V47.1c0-5.6 3-10.8 7.9-13.3 4.8-2.6 10.7-2.1 15.1 1.1l218.1 160.7c3.8 2.8 6.1 7.4 6.1 12.2s-2.3 9.4-6.1 12.2L280 380.7c-4.4 3.3-10.3 3.7-15.1 1.1s-7.9-7.7-7.9-13.3v-81.1c-150.5 6.4-209.9 116.8-220.4 180-1.1 7.2-7.2 12.5-14.3 12.5"
  })));
};
export default SvgReply;